import script from "./electronics.vue?vue&type=script&setup=true&lang=js"
export * from "./electronics.vue?vue&type=script&setup=true&lang=js"

import "./electronics.vue?vue&type=style&index=0&id=58364443&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58364443"]])

export default __exports__